import React, { useEffect } from "react";
import { Button, Popconfirm, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { managementActions } from "../store/actions";
import i18n from "./localization";
import "antd/lib/popover/style/index.css";
import "antd/lib/tag/style/index.css";
import "./style.css";

import i18nGlobal from "../../../localization";
import CustomButton from "../../../components/ButtonCustom";

const Block = (props) => {
  const { userId, lockoutEnd } = props;
  const dispatch = useDispatch();
  const isRu = useSelector((state) => state.globalReducer.isRu);
  let { isBlocked, isUnblocked } = useSelector(
    (state) => state.managementReducer
  );

  useEffect(() => {
    if (!lockoutEnd && isBlocked)
      dispatch(managementActions.getUser({ userId: userId }));
  }, [isBlocked]);

  useEffect(() => {
    if (lockoutEnd && isUnblocked)
      dispatch(managementActions.getUser({ userId: userId }));
  }, [isUnblocked]);

  useEffect(() => {
    return () => {
      dispatch(managementActions.clearIsBlockedUnblockedValues())
    }
  }, [])

  const block = () => {
    dispatch(managementActions.block({ userId: userId }));
  };

  const unblock = () => {
    dispatch(managementActions.unblock({ userId: userId }));
  };

  return (
    <div className="user-block">

      
      <Popconfirm
        title={i18n.confirm[isRu].format(
          i18n[lockoutEnd ? "unblock" : "block"][isRu].toLowerCase()
        )}
        onConfirm={() => (lockoutEnd ? unblock() : block())}
        okText={i18nGlobal.yes[isRu]}
        cancelText={i18nGlobal.no[isRu]}
      >
        {lockoutEnd ? (
          <CustomButton type="grey">{i18n.unblock[isRu]}</CustomButton>
        ) : (
          <CustomButton type="orange">
            <>
              <svg width="20" height="20" viewBox="0 0 20 20"  xmlns="http://www.w3.org/2000/svg">
                <path d="M10 18.3327C14.6024 18.3327 18.3333 14.6017 18.3333 9.99935C18.3333 5.39698 14.6024 1.66602 10 1.66602C5.39763 1.66602 1.66667 5.39698 1.66667 9.99935C1.66667 14.6017 5.39763 18.3327 10 18.3327Z" stroke-width="2"/>
                <path d="M4.16667 15.8327L15.8333 4.16602" stroke-width="2"/>
              </svg>
              <span>{i18n.block[isRu]}</span>
            </>
          </CustomButton>
        )}
      </Popconfirm>
      {lockoutEnd && (
        <>
          <p>
            {i18n.blockDate[isRu]}: {new Date(lockoutEnd).toLocaleString()}
          </p>
        </>
      )}
    </div>
  );
};

export default Block;
